import React, { useState, useEffect } from 'react';

import { getProductos } from '../../services/ProductService';
import { addToCart } from '../../services/CartService';


import '../static/Home.css';
import '../static/Productos.css';
import '../static/Global.css';



function Productos() {
    const [productos, setProductos] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [categoriaActiva, setCategoriaActiva] = useState('Todos');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProds = async () => {
            try {
                const data = await getProductos();
                //console.log("PRODUCTOS:", data); // 👈 IMPORTANTE
                setProductos(data);
                setLoading(false);
            } catch (error) {
                console.error("Error cargando productos en Novatech:", error);
                setLoading(false);
            }
        };
        fetchProds();
    }, []);

    // Obtener categorías únicas para los tabs
    const categorias = ['Todos', ...new Set(productos.map(p => p.categoria))];

    // Filtrado de productos
    // 1. Filtrado combinado: Primero por categoría y luego por búsqueda
    const productosFiltrados = productos.filter(p => {
        // Coincidencia de categoría
        const coincideCategoria = categoriaActiva === 'Todos' || p.categoria === categoriaActiva;

        // Coincidencia de búsqueda (si no hay nada escrito, es true)
        const coincideBusqueda = busqueda.trim() === '' ||
            p.nombre.toLowerCase().includes(busqueda.toLowerCase());

        return coincideCategoria && coincideBusqueda;
    });

    const handleAddToCart = (producto) => {
        addToCart(producto);
        alert(`${producto.nombre} se añadió al carrito`);
    };


    return (
        <main className="main__section">
            <h1 className="main__title">Catalogo</h1>

            <article className="container py-2">

                {/* TABS DE CATEGORÍAS */}
                <ul className="nav nav-tabs tabs-custom justify-content-center" id="productTabs" role="tablist">
                    {categorias.map(cat => (
                        <li className="nav-item" key={cat}>
                            <button
                                className={`nav-link ${categoriaActiva === cat ? 'active' : ''}`}
                                onClick={() => {
                                    setCategoriaActiva(cat);
                                    setBusqueda(''); // Limpia la búsqueda al cambiar de categoría
                                }}
                                type="button"
                            >
                                {cat}
                            </button>
                        </li>
                    ))}
                </ul>

                {/* BUSCADOR DENTRO DE LA CATEGORÍA */}
                <div className="container mt-3">
                    <div className="search-container" style={{ maxWidth: '400px', margin: '0 auto' }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={`Buscar en ${categoriaActiva}...`}
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </div>
                </div>


                <section className="tab-content pt-4">
                    <div className="container py-4">
                        {loading ? (
                            <div className="loader-wrapper">
                                <div className="novatech-spinner"></div>
                                <span className="loader-text">Cargando Productos...</span>
                            </div>
                        ) : (
                            <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                                {productosFiltrados.map((producto) => (
                                    // CAMBIO AQUÍ: Usar productos_id como key
                                    <div className="col" key={producto.productos_id}>
                                        <div className="product-card">
                                            <img src={producto.imagen} className="img-fluid" alt={producto.nombre} />

                                            <div className="product-info">
                                                <div className="price-row">
                                                    <span className="label">Precio</span>
                                                    <span className="value">S/ {producto.precio_venta}</span>
                                                </div>
                                                <div className="name-row">
                                                    <span className="label">Producto</span>
                                                    <span className="value">{producto.nombre}</span>
                                                </div>
                                                {/* Mostramos la descripción de la BD */}
                                                <p className="text-muted small mt-2">{producto.descripcion}</p>
                                            </div>

                                            <div className="d-flex justify-content-end mt-2">
                                                <button
                                                    className="buy-button"
                                                    onClick={() => handleAddToCart(producto)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-cart" viewBox="0 0 16 16">
                                                        <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </article>
        </main>
    );
}

export default Productos;